var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import { mapActions } from "vuex";
import { Component } from 'vue-property-decorator';
import AccountService from "../../api/AccountService";
import UserService from '../../api/UserService';
import RootType from "../../store/mutation-types";
import CommonService from "../../api/CommonService";
import CACHE_KEY from "../../constant/cacheKey";
import { ECache } from '../../enum/ECache';
import { Loading } from 'element-ui';
import GlobalVue from "../../globalVue";
import Company from '../Company';
import { mapGetters } from 'vuex';
import { CachePocily } from "../../common/Cache";
import DialogBindWechat from '@/components/DialogBindWechat.vue';
import VerifySmsCode from '@/components/VerifySmsCode.vue';
import PhoneCodeDialog from "./components/phoneCodeDialog.vue";
var Infor = (function (_super) {
    __extends(Infor, _super);
    function Infor() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.cache = CachePocily.getInstance(ECache.LocCache);
        _this.isEdit = false;
        _this.isRolePower = false;
        _this.hasMember = true;
        _this.infor = {
            account_nickname: '',
            account_email: '',
            account_position: '',
            account_gender: 1,
            is_admin: 0
        };
        _this.powerAuthList = [];
        _this.scoreVisbile = false;
        _this.logoutDialog = false;
        _this.logoutType = 0;
        _this.scoreData = [];
        _this.tooltipVisbile = false;
        return _this;
    }
    Infor.prototype.created = function () {
        var _this = this;
        this.service = AccountService.getInstance();
        this.userService = UserService.getInstance();
        this.commonService = CommonService.getInstance();
        this.getAccountInfo();
        this.getAuth('6010').then(function (pageAuth) {
            _this.isRolePower = pageAuth ? true : false;
        });
        console.log('------user', this.user);
    };
    Infor.prototype.mounted = function () {
        this.getRoleNameList();
    };
    Infor.prototype.toCompleteInfo = function () {
        var _this = this;
        this.tooltipVisbile = true;
        this.$nextTick(function () {
            _this.tooltipVisbile = false;
            _this.hideScoreModal();
            GlobalVue.$emit("addTab", {
                component: Company,
                title: "企业信息",
                name: "company",
                showExist: true,
            });
        });
    };
    Infor.prototype.hideScoreModal = function () {
        this.scoreVisbile = false;
    };
    Infor.prototype.showScoreModal = function () {
        this.scoreVisbile = true;
        if (!this.scoreData.length)
            this.getScoreDetail();
    };
    Infor.prototype.getScoreDetail = function () {
        var _this = this;
        var loadingInstance = Loading.service({ fullscreen: true });
        this.service
            .getEvaluateDetail()
            .then(function (res) {
            loadingInstance.close();
            var DATA = res.data.data || [];
            _this.scoreData = DATA;
        })
            .catch(function (err) {
            loadingInstance.close();
            _this.$message.error(err.message);
        });
    };
    Infor.prototype.getAccountInfo = function () {
        var _this = this;
        this.service.getAccountInfo().then(function (res) {
            _this.infor = res.data.data;
        }, function (error) {
            _this.$message.error(error.message);
        });
    };
    Infor.prototype.openBindWechatDialog = function () {
        var _this = this;
        var instance = this.$dialog(DialogBindWechat, {
            data: {
                user: this.infor
            }
        }, {
            title: "开启微信实时通知",
            width: 700,
            height: 400,
            zIndex: 1002,
        }).instance;
        instance.$on('success', function (data) {
            console.log('------success', data);
            _this.infor.is_bind_official_account = data.is_bind_official_account;
            _this.cache.save(CACHE_KEY.LOGIN, {
                ctime: new Date().getTime(),
                userInfo: JSON.stringify(_this.infor)
            });
            _this.$store.commit(RootType.UPDATE_LOGINMODEL, Object.assign({}, _this.user));
        });
    };
    Infor.prototype.unBindWechat = function () {
        var _this = this;
        this.$confirm('是否确定要解绑？解绑后，您将无法在微信接收到重要业务通知。', '提示')
            .then(function () {
            _this.$refs.codeDialog.show();
            console.log('------unbind', _this.$refs);
        }, function () { });
    };
    Infor.prototype.toggleBind = function () {
        this.infor.is_bind_official_account == 1 ? this.unBindWechat() : this.openBindWechatDialog();
    };
    Infor.prototype.handleUnBind = function (sms_code) {
        var _this = this;
        this.commonService.unbindAccount({ sms_code: sms_code, phone: this.user.phone })
            .then(function (res) {
            var _a = res.data, success = _a.success, msg = _a.msg;
            if (success) {
                var userInfo = _this.user;
                console.log('------res', res);
                _this.infor.is_bind_official_account = userInfo.is_bind_official_account = 0;
                _this.cache.save(CACHE_KEY.LOGIN, {
                    ctime: new Date().getTime(),
                    userInfo: JSON.stringify(userInfo)
                });
                _this.$store.commit(RootType.UPDATE_LOGINMODEL, Object.assign({}, userInfo));
                _this.$refs.codeDialog.close();
            }
            return success ? _this.$message.success(msg) : _this.$message.error(msg);
            console.log('------unbind sms_code', success, msg);
        }).catch(function (e) {
            _this.$message.error(e.message);
        });
    };
    Infor.prototype.save = function () {
        var _this = this;
        if (this.isEdit) {
            this.$validator.validateScopes().then(function (res) {
                if (res) {
                    _this.service.updateAccountInfo(_this.infor).then(function (res) {
                        _this.$message.success('保存成功！');
                        _this.isEdit = !_this.isEdit;
                    }, function (error) {
                        _this.$message.error(error.message);
                    });
                }
                ;
            });
        }
        else {
            this.isEdit = !this.isEdit;
        }
    };
    Infor.prototype.getRoleNameList = function () {
        var _this = this;
        this.userService.getRoleNameList().then(function (res) {
            _this.powerAuthList = Array.isArray(res.data.data) ? res.data.data : [];
        });
    };
    Infor.prototype.showLogoutDialog = function () {
        this.logoutType = 0;
        this.logoutDialog = true;
    };
    Infor.prototype.hideLogoutDialog = function () {
        this.logoutDialog = false;
    };
    Infor.prototype.confirmLogout = function () {
        var _this = this;
        this.logoutDialog = false;
        var loadingInstance = Loading.service({
            text: '正在检查账号情况，请稍后！'
        });
        this.commonService.getDestroyAllValidate().then(function (res) {
            loadingInstance.close();
            var data = res.data;
            if (data.code === 0) {
                _this.$message.success('账号初检通过，已向当前手机号发送验证码，请注意查收！');
                _this.$refs.phoneCodeDialog.show();
                _this.$refs.phoneCodeDialog.timerDown();
            }
            else {
                _this.logoutType = 1;
                _this.logoutMsg = data.msg;
                _this.logoutDialog = true;
            }
        });
    };
    Infor.prototype.destroyOpenDialog = function (data) {
        this.logoutType = 1;
        this.logoutMsg = data.msg;
        this.logoutDialog = true;
    };
    Infor = __decorate([
        Component({
            methods: __assign({}, mapActions(["getAuth"])),
            components: {
                PhoneCodeDialog: PhoneCodeDialog,
                VerifySmsCode: VerifySmsCode
            },
            computed: __assign({}, mapGetters({
                user: "user"
            }))
        })
    ], Infor);
    return Infor;
}(Vue));
export default Infor;
